var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"label label-info"},[_c('i',{staticClass:"fa fa-book",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.question.bookReference)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }